export const EVENT_WATCH_PARTY = "Watch Party";
export const EVENT_MEET_UP = "Meet-up";
export const EVENT_SCREENING = "Screening";
export const EVENT_TAILGATE = "Tailgate";
export const EVENT_TRAVEL = "Travel";
export const EVENT_AWAY_DAY = "Away Day";
export const EVENT_VIRTUAL_EVENT = "Virtual Event";
export const EVENT_SPECIAL_EVENT = "Special Event";
export const EVENT_VOLUNTEERING = "Volunteering";
export const EVENT_FUNDRAISER = "Fundraiser";
export const EVENT_SERVICE_PROJECT = "Service Project";
export const EVENT_TIFO = "Tifo";
export const EVENT_NEWS = "News";
export const EVENT_UPDATE = "Update";
export const EVENT_ANNOUNCEMENT = "Announcement";
export const EVENT_PODCAST = "Podcast";

export const defaultDateConfig = {
  [EVENT_WATCH_PARTY]: { homeFeed: 7, notifications: [1, 3] },
  [EVENT_MEET_UP]: { homeFeed: 7, notifications: [1, 3] },
  [EVENT_TAILGATE]: { homeFeed: 7, notifications: [1, 3] },
  [EVENT_SPECIAL_EVENT]: { homeFeed: 14, notifications: [3, 14] },
  [EVENT_TRAVEL]: { homeFeed: 14, notifications: [7, 14] },
  [EVENT_AWAY_DAY]: { homeFeed: 7, notifications: [1, 3] },
  [EVENT_VOLUNTEERING]: { homeFeed: 14, notifications: [1, 7] },
  [EVENT_FUNDRAISER]: { homeFeed: 7, notifications: [1, 3] },
  [EVENT_SERVICE_PROJECT]: { homeFeed: 7, notifications: [1, 3] },
  [EVENT_NEWS]: { homeFeed: -7, notifications: [0] },
  [EVENT_UPDATE]: { homeFeed: -7, notifications: [0] },
  [EVENT_VIRTUAL_EVENT]: { homeFeed: 7, notifications: [1, 3] },
  [EVENT_SCREENING]: { homeFeed: 7, notifications: [1, 3] },
  [EVENT_TIFO]: { homeFeed: 7, notifications: [1, 3] },
  [EVENT_PODCAST]: { homeFeed: 7, notifications: [1, 3] },
};

export const EVENTS_CONFIG = {
  "Social Events": [
    EVENT_WATCH_PARTY,
    EVENT_MEET_UP,
    EVENT_SCREENING,
    EVENT_TAILGATE,
    EVENT_TRAVEL,
    EVENT_AWAY_DAY,
    EVENT_VIRTUAL_EVENT,
    EVENT_SPECIAL_EVENT,
  ],
  "Community Events": [
    EVENT_VOLUNTEERING,
    EVENT_FUNDRAISER,
    EVENT_SERVICE_PROJECT,
    EVENT_TIFO,
  ],
  Announcements: [EVENT_NEWS, EVENT_PODCAST, EVENT_UPDATE, EVENT_ANNOUNCEMENT],
};

export const TIME_FORMAT = "HH:mm";
